import { yellow } from '@radix-ui/colors';

import { styled } from '../design-tokens';

export const HighlightMatched = styled('span', {
  color: '$fg',
  background: yellow.yellow10,
});
